/* eslint-disable no-use-before-define,no-mixed-operators,react-hooks/exhaustive-deps */
import React from 'react'
import BondLadderBuilder from './bond-ladder-builder'

const FRAMED = {
    'bond-ladder-builder': {reload:true},
}

export default ({view, args}) => {
    const [bondLadderBuilderTs, setBondLadderBuilderTs] = React.useState(0)

    React.useEffect(() => {
        let content = document.getElementById('content')
        if (content) {
            content.style.display = (view in FRAMED) ? 'none': 'block'
        }

        if (showFrame('bond-ladder-builder', view, args)) {
            setBondLadderBuilderTs(Date.now())
        }
    }, [view])

    return <React.Fragment>
        { bondLadderBuilderTs>0 && <BondLadderBuilder /> }
    </React.Fragment>

}

let showFrame = (name, view, args) => {
    let isShow = FRAMED[name] && view === name

    let framed = document.getElementById(`framed-${name}`)
    if (!framed) return isShow

    let frame = framed.querySelector('iframe')
    if (isShow && frame && !args.backFrom && FRAMED[name].reload) {
        frame.contentWindow.location.reload()
    }

    framed.style.display = isShow ? 'block': 'none'

    return isShow
}

